import { OurIcons } from "./OurIcons"
import { NavBottomLinksInterface, TitledListItemInterface } from "./Interfaces"
import { WebImages } from "./Images"

export class GlobalVars {

    static primaryColor = "#6b0f3d"
    static otherColors: Array<string> = [
        '#D50000', '#C51162', '#AA00FF', '#6200EA', '#304FFE',
        '#2962FF', '#0091EA', '#00B8D4', '#00BFA5', '#00C853',
        '#64DD17', '#AEEA00', '#FFD600', '#FFAB00', '#FF6D00',
        '#DD2C00'
    ]


    static myName = 'Oliwia Ankiewicz'
    static myOccupation = 'Software Engineer'
    static myDetails = "Hello, curious traveler! You must be here to learn a bit about me—excellent choice! My name is Oliwia, and I’m currently a Computer Science student at the Polish Naval Academy. When I’m not diving into algorithms and software validation, I work as a programming trainer, introducing young minds to the wonders of Python and C#. Before university, I graduated as a programming technician, gaining a solid foundation in various languages, though I’ve truly mastered only a select few. Beyond coding, I’m a lifelong learner (Gallup says so!), always eager to explore new ideas. I enjoy gaming, listening to audiobooks, and starting my mornings early with a fresh challenge. If you ever want to chat about technology, problem-solving, or just share a good programming joke—I'm all ears! 🚀"
    static myLeftAvatarImage = null
    static myRightAvatarImage = null
    static helperTexts = "We have a form available for you to write down any queries you may have, which will be sent directly to me. Would you like to view the form now?"
    static helperFormLink = ""

    static bottomLinks: Array<NavBottomLinksInterface> = [
        {
            svgPath: OurIcons.emailIcon,
            link: 'mailto:oliwiaankiewicz@gmail.com'
        },
        {
            svgPath: OurIcons.downloadIcon,
            link: 'https://drive.google.com/file/d/1tz7wcuW7HwlVcX886-4Dw3XO4CsVshmg/view?usp=sharing'
        }
    ]

    static skills: Array<TitledListItemInterface> = [
        {
            text: "Programming / Markup Languages",
            arr: [
                {
                    title: 'C#',
                    logo: 'https://images.seeklogo.com/logo-png/36/1/c-sharp-c-logo-png_seeklogo-363285.png',
                },
                {
                    title: 'C++',
                    logo: 'https://seeklogo.com/images/C/c-logo-1B1817C041-seeklogo.com.png',
                },
                {
                    title: 'Assembly (MASM x64, Intel)',
                    logo: 'https://www.shoplack.com/upload/cover/20120321015828.gif',
                },
                {
                    title: 'Java',
                    logo: 'https://www.vectorlogo.zone/logos/java/java-icon.svg',
                },
                {
                    title: 'Python',
                    logo: 'https://www.vectorlogo.zone/logos/python/python-icon.svg',
                },
                {
                    title: 'JavaScript',
                    logo: 'https://www.vectorlogo.zone/logos/javascript/javascript-icon.svg',
                },
                {
                    title: 'HTML',
                    logo: 'https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg',
                },
                {
                    title: 'CSS',
                    logo: 'https://seeklogo.com/images/C/css3-logo-F1923C8D0E-seeklogo.com.png',
                },
                {
                    title: 'Kotlin',
                    logo: 'https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg',
                },
                {
                    title: 'Dart',
                    logo: 'https://www.vectorlogo.zone/logos/dartlang/dartlang-icon.svg',
                },
                {
                    title: 'PHP',
                    logo: 'https://www.vectorlogo.zone/logos/php/php-ar21.svg',
                },
                {
                    title: 'SWIFT',
                    logo: 'https://www.vectorlogo.zone/logos/swift/swift-ar21.svg',
                },
                {
                    title: 'MatLab',
                    logo: 'https://upload.wikimedia.org/wikipedia/commons/2/21/Matlab_Logo.png',
                },
            ]
        },
        {
            text: "Databases",
            arr: [
                {
                    title: 'MongoDB',
                    logo: 'https://cdn.iconscout.com/icon/free/png-128/mongodb-3521676-2945120.png'
                },
                {
                    title: 'SQL',
                    logo: 'https://w7.pngwing.com/pngs/28/601/png-transparent-sql-logo-illustration-microsoft-azure-sql-database-microsoft-sql-server-database-blue-text-logo-thumbnail.png',
                },
            ]
        },
        {
            text: "Libraries / Frameworks / Techs",
            arr: [
                {
                    title: 'Raylib-cs',
                    logo: 'https://raw.githubusercontent.com/ChrisDill/Raylib-cs/master/Raylib-cs/logo/raylib-cs_256x256.png'
                },
                {
                    title: 'Xamarin.Forms',
                    logo: 'https://raw.githubusercontent.com/detain/svg-logos/b02ee1ac30c7ff4757278337c95588b01ed0954b/svg/x/xamarin.svg'
                },
                {
                    title: '.NET MAUI',
                    logo: 'https://i.imgur.com/M9HZgLs.png'
                },
                {
                    title: 'Android App Development',
                    logo: 'https://www.vectorlogo.zone/logos/android/android-icon.svg'
                },
                {
                    title: 'ReactJS',
                    logo: 'https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg'
                },
                {
                    title: 'Angular',
                    logo: 'https://angular.io/assets/images/logos/angular/angular.svg'
                },
                {
                    title: 'Scikit-learn',
                    logo: 'https://play-lh.googleusercontent.com/WNf1faY-_zBjmY6tyNw6m9ZLQm1DsJOszDD44CY_8Wa9aq9LfhUjSfX65P4RmygVDP1c'
                },
                {
                    title: 'OpenCV',
                    logo: 'https://www.vectorlogo.zone/logos/opencv/opencv-icon.svg'
                },
                {
                    title: 'Flutter',
                    logo: 'https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg'
                },
                {
                    title: 'Numpy',
                    logo: 'https://numpy.org/images/logo.svg'
                },
                {
                    title: 'TensorFlow',
                    logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRt0OU-18slF5XnJ0no2b9gA8twntZG6UngQ&s'
                },
                {
                    title: 'WPF',
                    logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTp34jR6zJxmuln4-IGeVPVldxLQm_T5Kmnkw&s'
                },
                {
                    title: 'WinForms',
                    logo: 'https://www.spec-india.com/wp-content/uploads/2023/05/winforms-logo.png'
                },
                {
                    title: 'Pandas',
                    logo: 'https://pandas.pydata.org/static/img/pandas.svg'
                },
                {
                    title: 'Matplotlib',
                    logo: 'https://matplotlib.org/3.1.0/_images/sphx_glr_logos2_001.png'
                },
                {
                    title: 'Flask',
                    logo: 'https://cdn.hackersandslackers.com/2020/05/flask.png'
                },
                {
                    title: 'Git',
                    logo: 'https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg'
                },
                {
                    title: 'Spring',
                    logo: 'https://www.svgrepo.com/show/354380/spring-icon.svg'
                },
            ]
        },
        {
            text: "Others",
            arr: [
                {
                    title: 'Android Studio',
                    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Android_Studio_Icon_3.6.svg/512px-Android_Studio_Icon_3.6.svg.png?20210301045217'
                },
                {
                    title: 'Visual Studio Code',
                    logo: 'https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_vscode_icon_130084.png'
                },
                {
                    title: 'Visual Studio',
                    logo: 'https://images.seeklogo.com/logo-png/27/2/visual-studio-logo-png_seeklogo-274066.png'
                },
                {
                    title: 'Jira',
                    logo: 'https://cdn.iconscout.com/icon/free/png-128/jira-3628861-3030001.png'
                },
                {
                    title: 'npm',
                    logo: 'https://www.vectorlogo.zone/logos/npmjs/npmjs-icon.svg'
                },
                {
                    title: 'Linux',
                    logo: 'https://www.freepnglogos.com/uploads/linux-png/file-icons-flat-linux-svg-wikimedia-commons-6.png'
                },
                {
                    title: 'Windows',
                    logo: 'https://pngimg.com/d/windows_logos_PNG9.png'
                },
                {
                    title: 'Canva',
                    logo: 'https://freelogopng.com/images/all_img/1656733637logo-canva-png.png'
                },
                {
                    title: 'Microsoft 365',
                    logo: 'https://cdn.iconscout.com/icon/free/png-256/free-microsoft-365-logo-icon-download-in-svg-png-gif-file-formats--application-productivity-apps-pack-logos-icons-8630405.png?f=webp'
                },
                {
                    title: 'Regex',
                    logo: 'https://seekicon.com/free-icon-download/regex_1.png'
                },
                {
                    title: 'JetBrains ReSharper',
                    logo: 'https://sklep.itmedia.pl/app/uploads/2024/02/ReSharper.jpg.webp'
                },
                {
                    title: 'JetBrains PyCharm',
                    logo: 'https://www.anysoft.pl/images/items/4637/pycharm-icon_big.png'
                },
            ]
        },
    ]

    static works: Array<TitledListItemInterface> = [
        {
            text: "Desktop Apps",
            arr: [
                {
                    title: 'School Secretary Application',
                    logo: 'https://i.imgur.com/IfyTKCK.jpeg',
                    desc: 'The School Secretary Application - SQL Express & winForms .NET',
                    link: 'https://github.com/livcia/secretary-office-winForms',
                    featured: true,
                },
                {
                    title: 'PlayGrid',
                    logo: 'https://i.imgur.com/KS6uSP6.jpeg',
                    desc: 'Game Library Management System, C# Console App - strong object-oriented approach',
                    link: 'https://github.com/livcia/PlayGrid',
                    featured: true,
                },
            ]
        }, 
        {
            text: "Mobile Apps",
            arr: [
                {
                    title: 'Tic Tac Toe 2Players',
                    logo: 'https://i.imgur.com/onWEDJz.jpeg',
                    desc: 'Tic-Tac-Toe game for two players, built in Android Studio using Java and XML.',
                    link: 'https://github.com/livcia/Tic-Tac-Toe_2players',
                    featured: false,
                },
                {
                    title: 'Simple Calculator',
                    logo: 'https://i.imgur.com/te5SGX9.jpeg',
                    desc: 'Simple calculator application built in Android Studio using Java and XML.',
                    link: 'https://github.com/livcia/Simple_Calculator',
                    featured: false,
                },
            ]
        },
        {
            text: "Web Apps",
            arr: [
                {
                    title: 'React To-Do List App',
                    logo: 'https://i.imgur.com/8ysWL34.jpeg',
                    desc: 'Efficiently create and manage tasks.',
                    link: 'https://github.com/livcia/REACT_todo_app',
                    featured: false,
                },
                {
                    title: 'React Expense Manager App',
                    logo: 'https://i.imgur.com/Mq3OK0t.jpeg',
                    desc: 'Track and manage your expenses',
                    link: 'https://github.com/livcia/REACT_expense_tracker',
                    featured: false,
                },
            ]
        },

    ]

    static contacts: Array<TitledListItemInterface> = [
        {
            text: "Contact me",
            arr: [
                {
                    title: 'Email',
                    logo: 'https://cdn3d.iconscout.com/3d/premium/thumb/email-address-4437044-3684811.png',
                    desc: 'oliwiaankiewicz@gmail.com',
                    link: 'mailto:oliwiaankiewicz@gmail.com'
                },
                {
                    title: 'LinkedIn',
                    logo: 'https://user-images.githubusercontent.com/6418354/155841027-8698cb12-7ddd-4604-a4ea-c618ddbc1cd8.png',
                    link: 'https://www.linkedin.com/in/oliwia-ankiewicz/',
                },
            ]
        },
        {
            text: "Others",
            arr: [
                {
                    title: 'GitHub',
                    logo: 'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
                    link: 'https://github.com/livcia'
                },

                {
                    title: 'Facebook',
                    logo: 'https://user-images.githubusercontent.com/6418354/155840898-9e2327aa-a280-45e3-8266-8268242abda4.png',
                    link: 'https://www.facebook.com/profile.php?id=100051412028469'
                },
                {
                    title: 'Instagram',
                    logo: 'https://user-images.githubusercontent.com/6418354/155841023-0b842621-56a3-42ec-81f1-3944034b09c7.png',
                    link: 'https://www.instagram.com/elwusia/'
                },
                {
                    title: "Medium",
                    logo: "https://seeklogo.com/images/M/medium-logo-93CDCF6451-seeklogo.com.png",
                    link: "https://medium.com/@oliwiaankiewicz"
                },
            ]
        },
    ]
}


